import React, { useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import Swal from "sweetalert2";

//redux
import { useDispatch } from "react-redux";
import * as auth from "../modules/auth/redux/AuthRedux";

type FunctionType = () => Promise<AxiosResponse<any>>;

export const useFetchData = ( apiCall:FunctionType, dependency:any[]=[] ) => {

  const [fetchResult, setFetchResult] = useState<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");

  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      const getData = async () => {
        try {
          const response = await apiCall();
          if (response.status === 200) {
            // console.log(response)
            setFetchResult(response);
          } else {
            // Handle other status codes
            Swal.fire({
              position: "center",
              icon: "error",
              title: `${response?.data?.message}`,
              showConfirmButton: false,
              timer: 1000,
            });
          }
        } catch (error: any) {
          if (error.response && error.response.status === 401) {
            // Handle unauthorized error here, such as redirecting to login page
            Swal.fire({
              position: "center",
              icon: "error",
              title: `${error.response.data.message}`,
              showConfirmButton: false,
              timer: 1000,
            });
            dispatch(auth?.actions.logout());
          } else {
            setError("Error occurred");
            Swal.fire({
              position: "center",
              icon: "error",
              title: `${error.response.data.message}`,
              showConfirmButton: false,
              timer: 1000,
            });
          }
        } finally {
          setLoading(false);
        }
      };
      getData();
    }, 200);
    
  }, [...dependency]);

  return [fetchResult, loading, error];
};
